import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import App from './App.jsx';
import { CartProvider } from './context/CartContext.jsx';
import { StoreLayoutSkeleton } from './components/StoreLayoutSkeleton.jsx';
import storeClient from './api/storeClient';
import './index.css';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN_STORE,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || 0.1),
  environment: import.meta.env.MODE,
});

const nullStripePromise = Promise.resolve(null);

function StoreBootstrap() {
  const [stripePromise, setStripePromise] = useState(nullStripePromise);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const loadStripeForTenant = async () => {
      try {
        const { data } = await storeClient.get('/store/settings');
        const paymentProvider = data?.data?.payment_provider || 'stripe';
        const stripePublicKey = data?.data?.stripe_public_key;

        if (paymentProvider === 'stripe' && stripePublicKey) {
          setStripePromise(loadStripe(stripePublicKey));
        } else {
          setStripePromise(nullStripePromise);
        }
      } catch (error) {
        console.error('Error loading tenant Stripe settings:', error);
        setStripePromise(nullStripePromise);
      } finally {
        setReady(true);
      }
    };

    loadStripeForTenant();
  }, []);

  if (!ready) {
    return <StoreLayoutSkeleton />;
  }

  return (
    <Elements stripe={stripePromise}>
      <CartProvider>
        <App />
      </CartProvider>
    </Elements>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <StoreBootstrap />
  </React.StrictMode>,
);
